import axios from "../utils/axios";

export const getBlogs = async (params = {}) => {
  try {
    const response = await axios.get("/admin/blogs", { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs");
  }
};

export const getBlogById = async (blogId) => {
  try {
    const response = await axios.get(`/admin/blogs/${blogId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blog");
  }
};

export const uploadFile = async (file, uploadPath, isPublic = false) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("uploadPath", uploadPath);

    const response = await axios.post(
      `/user/upload/multipart?public=${isPublic}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to upload file");
  }
};

export const createBlog = async (blogData) => {
  try {
    const response = await axios.post("/admin/blogs", blogData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to create blog");
  }
};

export const updateBlog = async (blogId, blogData) => {
  try {
    const response = await axios.put(`/admin/blogs/${blogId}`, blogData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update blog");
  }
};

export const deleteBlog = async (blogId) => {
  try {
    const response = await axios.delete(`/admin/blogs/${blogId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete blog");
  }
};
